import { render, staticRenderFns } from "./AbkAttachments.vue?vue&type=template&id=c7c10c08&scoped=true&"
import script from "./AbkAttachments.vue?vue&type=script&lang=js&"
export * from "./AbkAttachments.vue?vue&type=script&lang=js&"
import style0 from "./AbkAttachments.vue?vue&type=style&index=0&id=c7c10c08&scoped=true&lang=scss&"
import style1 from "./AbkAttachments.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c10c08",
  null
  
)

export default component.exports